/* eslint-disable react/require-default-props */
import { memo } from 'react';
import './RowDefiner.scss';
import PropTypes from 'prop-types';

import PartJobLine from '../PartJobLine/PartJobLine';
import UnitBoxes from '../UnitBoxes/UnitBoxes';

const RowDefiner = ({
  nameLine,
  namePosition,
  numberLine,
  numberPosition,
  unitMeasurement,
  ubicationName,
  ubicationFinished,
  lineBlockedBySap
}) => (
  <>
    {nameLine ? (
      <PartJobLine
        backgroundColorLine="#E9D9F1"
        backgroundColorPosition="#CFE0FF"
        backgroundUnitMeasurement="#F5F5F5"
        colorLine="#484848"
        colorPostion="#484848"
        colorUnitMeasurement="#484848"
        lineBlockedBySap={lineBlockedBySap}
        nameLine={nameLine}
        namePosition={namePosition}
        numberLine={numberLine}
        numberPosition={numberPosition}
        unitMeasurement={unitMeasurement}
      />
    ) : (
      <div className="row-definer">
        <span>Ubicación {`${ubicationFinished ? ' (Serv. Finalizado)' : ''}`} </span>
        <div className="ubication-name-description">
          <UnitBoxes backgroundColor="#F7F7F7" color="#000">
            {ubicationName}
          </UnitBoxes>
        </div>
      </div>
    )}
  </>
);

export default memo(RowDefiner);

RowDefiner.propTypes = {
  nameLine: PropTypes.string,
  namePosition: PropTypes.string,
  numberLine: PropTypes.number,
  numberPosition: PropTypes.number,
  unitMeasurement: PropTypes.string,
  ubicationName: PropTypes.string,
  ubicationFinished: PropTypes.bool,
  lineBlockedBySap: PropTypes.bool
};
